// extracted by mini-css-extract-plugin
export default {"modal__header":"ConfirmModal_modal__header__t-TYG","modal__title":"ConfirmModal_modal__title__0bCI0","modal__content":"ConfirmModal_modal__content__tLiTp"};